import { SingleCallCardModule } from '@addins/core/singlecallcard';
import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SagaPipeModule } from '@app/pipes/module';
import { IonicModule } from '@ionic/angular';
import { Addin, AddinModule } from '@techwan/ionic-core';
import { SharedModule } from '../../../modules/shared/shared.module';
import { MediaMessageTextEditorComponent } from '../media/components/media-message-text-editor/media-message-text-editor.component';
import { MediaMessageAttachmentComponent } from './components/media-message-attachment/media-message-attachment.component';
import { MediaMessageDeploymentComponent } from './components/media-message-deployment/media-message-deployment.component';
import { MediaMessageItemComponent } from './components/media-message-item/media-message-item.component';
import { MediaMessagesListComponent } from './components/media-messages-list/media-messages-list.component';
import { MediaMessagesNewComponent } from './components/media-messages-new/media-messages-new.component';
import { MessagesMenuSetupService } from './services/executables/messages-menu-setup/messages-menu-setup.service';
import { MediaMessagesAvailableService } from './services/media-messages/media-messages-available/media-messages-available.service';
import { MediaMessagesFilterService } from './services/media-messages/media-messages-filter/media-messages-filter.service';
import { MediaMessagesNewService } from './services/media-messages/media-messages-new/media-messages-new.service';
import { MediaMessagesService } from './services/media-messages/media-messages/media-messages.service';
import { MessagesMenuControllerService } from './services/messages-menu-controller/messages-menu-controller.service';
import { MediaMessagesViewComponent } from './views/media-messages-view/media-messages-view.component';

const components = [
  MediaMessageTextEditorComponent,
  MediaMessageAttachmentComponent,
  MediaMessageDeploymentComponent,
  MediaMessageItemComponent,
  MediaMessagesListComponent,
  MediaMessagesNewComponent
];

const views = [MediaMessagesViewComponent];

const declarations = [...components, ...views];

const services = [
  MediaMessagesAvailableService,
  MediaMessagesNewService,
  MediaMessagesService,
  MessagesMenuControllerService,
  MediaMessagesFilterService
];

const executables = [MessagesMenuSetupService];

@Addin({
  name: 'MediaMessages',
  require: ['Media']
})
@NgModule({
  declarations: [...declarations],
  providers: [...services, ...executables],
  imports: [IonicModule, FormsModule, CommonModule, SharedModule, SingleCallCardModule, SagaPipeModule]
})
export class MediaMessageModule extends AddinModule {
  constructor(injector: Injector) {
    super(injector, views, executables);
  }
}
